/*
 * Copyright (C) 2024 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and
 * should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly
 * prohibited.
 */

import { MobiledataOffRounded } from '@mui/icons-material';
import AirplanemodeActive from '@mui/icons-material/AirplanemodeActive';
import AssessmentIcon from '@mui/icons-material/Assessment';
import DeviceHubIcon from '@mui/icons-material/DeviceHub';
import Flag from '@mui/icons-material/Flag';
import Inbox from '@mui/icons-material/Inbox';
import Map from '@mui/icons-material/Map';
import MaintenanceIcon from './MaintenanceIcon';
import { Authorities } from '../../../../shared/entities/user';

export enum MenuItems {
  fleet = 'fleet',
  flights = 'flights',
  maintenance = 'maintenance',
  tickets = 'tickets',
  plans = 'plans',
  dataUsage = 'data-usage',
  provisioning = 'provisioning',
  manualDowntime = 'manual-downtime',
  transportMonitoring = 'transport-monitoring',
}

export interface MenuItem {
  icon: JSX.Element;
  text: string;
  visible: boolean;
  restrictedToRoles?: Authorities[];
}

export const menuContent: Record<MenuItems, MenuItem> = {
  [MenuItems.fleet]: {
    icon: <Map />,
    text: 'My Fleet',
    visible: true,
  },
  [MenuItems.flights]: {
    icon: <AirplanemodeActive />,
    text: 'All Flights',
    visible: false,
  },
  [MenuItems.maintenance]: {
    icon: <MaintenanceIcon />,
    text: 'Maintenance',
    visible: false,
  },
  [MenuItems.plans]: {
    icon: <Flag />,
    text: 'Mission Planning',
    visible: true,
  },
  [MenuItems.tickets]: {
    icon: <Inbox />,
    text: 'Open Tickets',
    visible: true,
  },
  [MenuItems.dataUsage]: {
    icon: <AssessmentIcon />,
    text: 'Data Usage',
    visible: true,
    restrictedToRoles: [Authorities.ROLE_VIEW_HISTORICAL_CHARTS],
  },
  [MenuItems.provisioning]: {
    icon: <DeviceHubIcon />,
    text: 'Provisioning',
    visible: true,
    restrictedToRoles: [
      Authorities.ROLE_DEV_VIEW_ONLY,
      Authorities.ROLE_TDS_STCR_APPROVER,
      Authorities.ROLE_PROVISIONING_RW,
      Authorities.ROLE_TDS_ROLE_RW,
      Authorities.ROLE_TDS_CLIENT_RW,
    ],
  },
  [MenuItems.manualDowntime]: {
    icon: <MobiledataOffRounded />,
    text: 'Manual Downtime',
    visible: true,
    restrictedToRoles: [Authorities.ROLE_MANUAL_DOWNTIME],
  },
  [MenuItems.transportMonitoring]: {
    icon: <Map />,
    text: 'Transport Monitoring',
    visible: true,
    restrictedToRoles: [
      Authorities.ROLE_DEV_VIEW_ONLY,
      Authorities.ROLE_TRANSPORT_MONITORING_VIEW,
      Authorities.ROLE_ISAN_CUSTOMER,
      Authorities.ROLE_ISAN_DEV,
    ],
  },
};

export default MenuItems;
